<template>
  <div class="scrollable-list">
    <div
      v-for="(item, index) in items"
      :key="itemKey(item, index)"
      ref="items"
      class="list-item"
    >
      <slot name="list-item" :item :index />
    </div>
  </div>
</template>

<script setup lang="ts" generic="T">
import { computed, useTemplateRef, watchEffect } from "vue";

type ScrollableListProps<T> = {
  items: T[];
  itemKey: (item: T, index: number) => string | number;
  scrollOffset?: number;
  scrollToIndex?: number;
};

const {
  scrollToIndex,
  items,
  itemKey,
  scrollOffset = 0,
} = defineProps<ScrollableListProps<T>>();

const scrollMarginTop = computed(() => `${scrollOffset}px`);

const itemRefs = useTemplateRef("items");

watchEffect(() => {
  if (scrollToIndex && itemRefs.value) {
    itemRefs.value[scrollToIndex]?.scrollIntoView({
      behavior: "smooth",
    });
  }
});
</script>

<style scoped lang="scss">
.scrollable-list {
  overflow-y: auto;
  height: 100%;

  .list-item {
    scroll-margin-top: v-bind(scrollMarginTop);
  }
}
</style>
